<template>
  <div>
    <v-container>
      <v-col cols="12">
        <v-row>
          <span class="screenHeading">Community Configuration</span>
          <v-spacer></v-spacer>
        </v-row>
        <v-row>
          <a :href="`/CommunityConfig`" class="blue-link">Create a new community</a>
        </v-row>
      </v-col>
      <v-container>
        <v-row dense>
          <v-col cols="8" class="pa-0"
            ><strong>{{ $t('Community_Name') }}</strong></v-col
          >
          <v-col cols="4" class="pa-0"
            ><strong>{{ $t('Community_Abbreviation') }}</strong></v-col
          >
        </v-row>
      </v-container>
      <div v-for="item in communities" v-bind:key="item.id">
        <router-link :to="`${item.communityAbbreviation}/CommunityConfig/`">
          <v-card>
            <v-container>
              <v-row>
                <v-col cols="8">{{ item.communityName }}</v-col>
                <v-col cols="4">{{ item.communityAbbreviation }}</v-col>
              </v-row>
            </v-container>
          </v-card>
        </router-link>
      </div>
    </v-container>
    <toaster ref="toaster"></toaster>
  </div>
</template>

<script>
import MOCAdminService from '@/services/admin.service'
import Toaster from '@/components/Toaster'
export default {
  name: 'Communities',
  data: () => ({
    edit: false,
    confirm: false,
    posting: false,
    // people pickers
    callResult: null,
    errorObject: null,
    successMessage: null,
    valid: false,
    isSaving: false,
    dialog: false,
    community: {
      shortName: null,
      title: null
    },
    snackbar: {
      text: 'hey',
      show: false
    },
    minimumTitleLength: 3,
    maximumTitleLength: 60,
    minimumShortNameLength: 3,
    maximumShortNameLength: 60,
    communities: [],
    gettingCommunities: false
  }),
  components: {
    Toaster
  },
  methods: {
    getData: function() {
      if (!this.gettingCommunities) {
        MOCAdminService.getUserCommunities()
          .then(
            succ =>
              (this.communities = [
                ...succ.sort((a, b) => (a.communityName.toUpperCase() > b.communityName.toUpperCase() ? 1 : -1))
              ])
      )
          .catch(() => {
            // TODO: deterimine if we need to do anything here
          })
          .finally(() => {
            this.gettingCommunities = false
          })
      }
    },
    alert: function() {
      if (this.errorObject != null) {
        setTimeout(() => {
          this.errorObject = null
        }, 3000)
      }
      return this.errorObject != null
    },
    successAlert: function() {
      if (this.successMessage != null) {
        setTimeout(() => {
          this.successMessage = null
        }, 3000)
      }
      return this.successMessage != null
    }
  },
  created() {
    this.getData()
  }
}
</script>

<style scoped></style>
